import { Page } from 'types/pages'

//* PUBLIC PAGES
export const PAGE_LOGIN: Page = { id: 'LOGIN', path: '/login', name: 'Login' }

export const PAGE_FORGOT_PASSWORD: Page = {
  id: 'FORGOT_PASSWORD',
  path: '/forgot-password',
  name: 'Forgot Password',
}

export const PAGE_RESET_PASSWORD: Page = {
  id: 'RESET_PASSWORD',
  path: '/reset',
  name: 'Reset Password',
}

export const PAGE_NOT_FOUND: Page = {
  id: 'NOT_FOUND',
  path: '/not-found',
  name: 'Page Not Found',
}

//! PROTECTED PAGES
export const PAGE_DASHBOARD: Page = {
  id: 'DASHBOARD',
  path: '/',
  name: 'Dashboard',
}

export const PAGE_MASTER_DATA: Page = {
  id: 'MASTER_DATA',
  path: '/master-data',
  name: 'Master Data',
}

export const PAGE_MASTER_DATA_UPDATE: Page = {
  id: 'MASTER_DATA_UPDATE',
  path: '/master-data/update',
  name: 'Update Master Data',
}

export const PAGE_INVENTORY: Page = {
  id: 'INVENTORY',
  path: '/inventory',
  name: 'Inventory',
}

export const PAGE_INVENTORY_UPDATE: Page = {
  id: 'INVENTORY_UPDATE',
  path: '/inventory/update',
  name: 'Inventory Update',
}

export const PAGE_PRICING: Page = {
  id: 'PRICING',
  path: '/pricing',
  name: 'Pricing',
}

export const PAGE_STORE_ORDERS: Page = {
  id: 'STORE_ORDERS',
  path: '/store-orders',
  name: 'Store Orders',
}

export const PAGE_ADMIN_ORDERS: Page = {
  id: 'ADMIN_ORDERS',
  path: '/orders',
  name: 'Admin Orders',
}

export const PAGE_ADMIN_ORDERS_DETAILS: Page = {
  id: PAGE_ADMIN_ORDERS.id + '_DETAILS',
  path: '/orders',
  name: 'Orders Details',
}

export const PAGE_PARTIAL_RMA: Page = {
  id: 'PAGE_RMA',
  path: '/orders/rma',
  name: 'Orders Details',
}

export const PAGE_RMA_DETAILS: Page = {
  id: 'PAGE_RMA',
  path: '/orders/rma',
  name: 'RMA Details',
}

export const PAGE_PRICING_UPDATE: Page = {
  id: 'PRICING_UPDATE',
  path: '/pricing/update',
  name: 'Pricing Update',
}

export const PAGE_SMART_OOS: Page = {
  id: 'SMART_OOS',
  path: '/smart-oos',
  name: 'Smart OOS',
}

export const PAGE_FUNC_JOBS: Page = {
  id: 'FUNCTION_AND_JOBS',
  path: '/function-jobs',
  name: 'Function & Jobs',
}

export const PAGE_ERP_API_LOGS: Page = {
  id: 'ERP_API_LOGS',
  path: '/erp-api-logs',
  name: 'ERP API Logs',
}

export const PAGE_POS_API_LOGS: Page = {
  id: 'POS_API_LOGS',
  path: '/pos-api-logs',
  name: 'POS API Logs',
}

export const PAGE_FTP_CREATION_LOGS: Page = {
  id: 'FTP_CREATION_LOGS',
  path: '/ftp-creation-logs',
  name: 'FTP Creation Logs',
}

export const PAGE_AGGREGATOR_API_LOG: Page = {
  id: 'AGGREGATOR_API_LOG',
  path: '/aggregator-api-log',
  name: 'Aggregators API Logs',
}

export const PAGE_IMPORT_LOGS: Page = {
  id: 'IMPORT_LOGS',
  path: '/import-logs',
  name: 'Import Logs',
}

export const PAGE_EXPORT_LOGS: Page = {
  id: 'EXPORT_LOGS',
  path: '/export-logs',
  name: 'Export Logs',
}

export const PAGE_ORDERS_LOGS: Page = {
  id: 'ORDERS_LOGS',
  path: '/orders-logs',
  name: 'Orders Logs',
}

export const PAGE_RECONCILIATION_LOGS: Page = {
  id: 'RECONCILIATION_LOGS',
  path: '/reconciliation-logs',
  name: 'Reconciliation Logs',
}

export const PAGE_CONFIG: Page = {
  id: 'CONFIGURATIONS',
  path: '/configurations',
  name: 'Configurations',
}

export const PAGE_USER_MGMT: Page = {
  id: 'USER_MANAGEMENT',
  path: '/user-management',
  name: 'User Management',
}

export const PAGE_ADD_USER: Page = {
  id: 'ADD_USER',
  path: '/user-management/add',
  name: 'Add User',
}

export const PAGE_UPDATE_USER: Page = {
  id: 'UPDATE_USER',
  path: '/user-management/update',
  name: 'Update User',
}
// -------------- Store Management --------------
export const PAGE_STORE_MGMT: Page = {
  id: 'STORE_MANAGEMENT',
  path: '/store-management',
  name: 'Store Management',
}

export const PAGE_ADD_STORE: Page = {
  id: 'ADD_STORE',
  path: '/store-management/add',
  name: 'Add Store',
}

export const PAGE_UPDATE_STORE: Page = {
  id: 'ADD_STORE',
  path: '/store-management/update',
  name: 'Update Store',
}

export const PAGE_AGGREGATOR_MANAGEMENT: Page = {
  id: 'AGGREGATORS_MANAGEMENT',
  path: '/aggregators-management',
  name: 'Aggregators Management',
}

export const PAGE_ADD_AGGREGATOR: Page = {
  id: 'ADD_AGGREGATORS',
  path: '/aggregators-management/add',
  name: 'Add Aggregator',
}

export const PAGE_UPDATE_AGGREGATOR: Page = {
  id: 'UPDATE_AGGREGATORS',
  path: '/aggregators-management/update',
  name: 'Update Aggregator',
}

export const PAGE_FTP_CONFIG: Page = {
  id: 'FTP_CONFIGURATIONS',
  path: '/ftp-configurations',
  name: 'FTP Configurations',
}

export const PROTECTED_PAGES: Page[] = [
  PAGE_STORE_ORDERS,
  PAGE_ADMIN_ORDERS,
  PAGE_MASTER_DATA,
  PAGE_INVENTORY,
  PAGE_PRICING,
  PAGE_SMART_OOS,
  PAGE_FUNC_JOBS,
  PAGE_ERP_API_LOGS,
  PAGE_POS_API_LOGS,
  PAGE_FTP_CREATION_LOGS,
  PAGE_AGGREGATOR_API_LOG,
  PAGE_IMPORT_LOGS,
  PAGE_EXPORT_LOGS,
  PAGE_ORDERS_LOGS,
  PAGE_RECONCILIATION_LOGS,
  PAGE_CONFIG,
  PAGE_USER_MGMT,
  PAGE_STORE_MGMT,
  PAGE_AGGREGATOR_MANAGEMENT,
  PAGE_FTP_CONFIG,
]
